function getTextNodesPreserveWhitespace(node) {
  const textNodes = [];
  if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()) {
    textNodes.push(node);
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    for (let child of node.childNodes) {
      textNodes.push(...getTextNodesPreserveWhitespace(child));
    }
  }
  return textNodes;
}

async function translateText(texts, targetLang, url) {
  const locale = $('html').attr('lang');
  const filteredTexts = texts.filter(text => text?.trim());
  if (filteredTexts.length === 0) return texts;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      targetLang: locale,
      sourceLang: "en",
      filteredTexts: filteredTexts
    })
  });

  const data = await response.json();
  return data;
}

async function translateElements(whitelist, targetLang, isAntiqua, url) {
  const elements = [];
  whitelist.forEach(item => {
    document.querySelectorAll(item.value).forEach(el => elements.push(el));
  });

  const allTextNodes = [];
  const textContents = [];
  const whitespaceInfo = [];

  if (isAntiqua) {
    await new Promise(resolve => setTimeout(resolve, 1000));
    for (const el of elements) {
      const shadow = el.shadowRoot;
      if (!shadow) {
        console.warn('No shadowRoot found for element:', el);
        continue;
      }
      const slot = shadow.querySelector('slot');
      if (!slot) {
        console.warn('No <slot> found in shadowRoot for element:', el);
        continue;
      }
      const nodes = slot.assignedNodes({ flatten: true });
      nodes.forEach(node => {
        const textNodes = getTextNodesPreserveWhitespace(node);
        textNodes.forEach(textNode => {
          const originalText = textNode.nodeValue;
          const leadingSpaces = originalText.match(/^\s*/)?.[0] || '';
          const trailingSpaces = originalText.match(/\s*$/)?.[0] || '';
          const trimmedText = originalText.trim();

          whitespaceInfo.push({ leadingSpaces, trailingSpaces });
          allTextNodes.push(textNode);
          textContents.push(trimmedText);
        });
      });
    }
  } else {
    elements.forEach(el => {
      const nodes = getTextNodesPreserveWhitespace(el);
      nodes.forEach(node => {
        const originalText = node.nodeValue;
        const leadingSpaces = originalText.match(/^\s*/)?.[0] || '';
        const trailingSpaces = originalText.match(/\s*$/)?.[0] || '';
        const trimmedText = originalText.trim();

        whitespaceInfo.push({ leadingSpaces, trailingSpaces });
        allTextNodes.push(node);
        textContents.push(trimmedText);
      });
    });
  }

  const translated = await translateText(textContents, targetLang, url);

  allTextNodes.forEach((node, i) => {
    if (translated[i]) {
      const { leadingSpaces, trailingSpaces } = whitespaceInfo[i];
      node.nodeValue = leadingSpaces + translated[i] + trailingSpaces;
    }
  });
}